import React from 'react';
import { NavLink } from 'react-router-dom';

const ClientsCrumb = () => <NavLink to="/core/clients">Clients</NavLink>;

export default ClientsCrumb;
